// AlertPreferencesModal.jsx
import React, { useState, useEffect } from 'react';
import './AlertModal.css'

export default function AlertPreferencesModal({ userId, onClose }) {
  const [mode, setMode] = useState("price");
  const [preferences, setPreferences] = useState([
    { recommendation: '', confidence: '', gain: '', token: '' }
  ]);
  const [trendPreferences, setTrendPreferences] = useState([
  { token: '', direction: 'long' }
]);

  const [saving, setSaving] = useState(false);
  const isLocal = window.location.hostname === 'localhost';
  const baseUrl = isLocal
    ? 'http://localhost:5000'
    : 'https://www.trendscout.club';

  const updatePref = (index, key, value) => {
  setPreferences(prev => {
    const copy = [...prev];
    copy[index] = { ...copy[index], [key]: value };
    return copy;
  });
};


useEffect(() => {
  async function fetchPrefs() {
    try {
      const [priceRes, trendRes] = await Promise.all([
        fetch(`${baseUrl}/api/user/${userId}/alert-preferences`),
        fetch(`${baseUrl}/api/user/${userId}/trend-alert-preferences`)
      ]);
      const priceJson = await priceRes.json();
      const trendJson = await trendRes.json();
      if (Array.isArray(priceJson)) setPreferences(priceJson);
      if (Array.isArray(trendJson)) setTrendPreferences(trendJson);
    } catch (err) {
      console.error("Failed to fetch alert preferences", err);
    }
  }

  fetchPrefs(); // ✅ inject here
}, [userId]);


const handleSave = async () => {
  setSaving(true);
  const url = mode === "price"
    ? `${baseUrl}/api/user/${userId}/alert-preferences`
    : `${baseUrl}/api/user/${userId}/trend-alert-preferences`;

const payload = mode === "price"
  ? { preferences }
  : { trendAlertPreferences: trendPreferences };


  try {
    const res = await fetch(url, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Failed to save");
    onClose();
  } catch (err) {
    alert("Error saving preferences");
  } finally {
    setSaving(false);
  }
};

const updateTrendPref = (index, key, value) => {
  setTrendPreferences(prev => {
    const copy = [...prev];
    copy[index] = { ...copy[index], [key]: value };
    return copy;
  });
};


  return (
    <div className="alert-modal-overlay">
      <div className="alert-modal">
            <h3>🔔 Alert Preferences</h3>
    <div className="button-group">
      <button onClick={() => setMode("price")}>📈 New Trade Alerts</button>
      <button onClick={() => setMode("trend")}>📉 Trend Alerts</button>
    </div>
{mode === "price" && (
  <div className="alert-grid">
    {preferences.map((pref, idx) => (
      <div key={idx} className="alert-preference-block">
        <div className="pref-title">📌 Alert #{idx + 1}</div>

        <label>Recommendation</label>
        <select value={pref.recommendation} onChange={(e) => updatePref(idx, 'recommendation', e.target.value)}>
          <option value="">Any</option>
          <option value="BUY">BUY</option>
          <option value="STRONG BUY">STRONG BUY</option>
          <option value="SELL">SELL</option>
          <option value="STRONG SELL">STRONG SELL</option>
        </select>

        <label>Min Confidence (1–10)</label>
        <input
          type="number"
          min="1"
          max="10"
          value={pref.confidence}
          onChange={(e) => updatePref(idx, 'confidence', e.target.value)}
        />

        <label>Min Score</label>
        <input
          type="number"
          min="0"
          max="20"
          step="0.1"
          value={pref.minScore ?? 3}
          onChange={(e) => updatePref(idx, 'minScore', Math.min(Number(e.target.value), 20))}
        />


        <label>Min Gain (%)</label>
        <input
          type="number"
          min="0"
          step="0.1"
          value={pref.gain}
          onChange={(e) => updatePref(idx, 'gain', e.target.value)}
        />

        <label>Token (optional)</label>
        <input
          value={pref.token}
          onChange={(e) => updatePref(idx, 'token', e.target.value)}
        />
      </div>
    ))}
  </div>
)}

{mode === "trend" && (
  <div className="alert-grid">
    {trendPreferences.map((pref, idx) => (
      <div key={idx} className="alert-preference-block">
        <div className="pref-title">📉 Trend Alert #{idx + 1}</div>

        <label>Token</label>
        <input
          value={pref.token}
          onChange={(e) => updateTrendPref(idx, 'token', e.target.value)}
        />

        <label>Direction</label>
        <select value={pref.direction} onChange={(e) => updateTrendPref(idx, 'direction', e.target.value)}>
          <option value="long">Long</option>
          <option value="short">Short</option>
        </select>
      </div>
    ))}
  </div>
)}



<div className="modal-buttons">
  {mode === "price" && preferences.length < 4 && (
    <button onClick={() => setPreferences([...preferences, { recommendation: '', confidence: '', gain: '', token: '', minScore: ''  }])}>
      ➕ Add Alert
    </button>
  )}
  {mode === "price" && preferences.length > 1 && (
    <button onClick={() => setPreferences(preferences.slice(0, -1))}>
      🗑️ Remove Last
    </button>
  )}

  {mode === "trend" && trendPreferences.length < 2 && (
    <button onClick={() => setTrendPreferences([...trendPreferences, { token: '', direction: 'long' }])}>
      ➕ Add Trend Alert
    </button>
  )}
  {mode === "trend" && trendPreferences.length > 1 && (
    <button onClick={() => setTrendPreferences(trendPreferences.slice(0, -1))}>
      🗑️ Remove Last Trend
    </button>
  )}
</div>


        <div className="modal-buttons">
          <button onClick={handleSave} disabled={saving}>✅ Save</button>
          <button onClick={onClose}>❌ Cancel</button>
        </div>
      </div>
    </div>
  );
}